import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

import {
  FaChevronRight,
  FaWallet,
  FaChartPie,
  FaShoppingCart,
  FaBoxOpen,
  FaTruckMoving,
  FaProjectDiagram,
  FaIndustry,
  FaCheckCircle,
  FaRobot,
  FaCog,
  FaBox
} from "react-icons/fa";

import { hasPermission } from "../utils/permission";

const Sidebar = ({
  isOpen,
  width,
  isDragging,
  handleMouseDown,
}) => {
  const user = JSON.parse(
    localStorage.getItem("user")
  );

  const [openMenus, setOpenMenus] =
    useState(() => {
      const saved = localStorage.getItem(
        "sidebarOpenMenus"
      );

      return saved
        ? JSON.parse(saved)
        : {};
    });

  useEffect(() => {
    localStorage.setItem(
      "sidebarOpenMenus",
      JSON.stringify(openMenus)
    );
  }, [openMenus]);

  const toggleMenu = (key) => {
    setOpenMenus((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  /* SCROLL POSITION PERSISTENCE
     Fixes: opening a submenu, scrolling down, then clicking a link
     (e.g. Configuration -> Location) caused the sidebar to jump back
     to the top on the re-render/navigation, since only openMenus was
     persisted, not scroll position. */
  const sidebarRef = useRef(null);
  const scrollRestored = useRef(false);

  useLayoutEffect(() => {
    if (scrollRestored.current) return;

    const savedScroll = localStorage.getItem(
      "sidebarScrollTop"
    );

    if (savedScroll && sidebarRef.current) {
      sidebarRef.current.scrollTop = Number(savedScroll);
    }

    scrollRestored.current = true;
  }, []);

  const scrollSaveTimeout = useRef(null);

  const handleSidebarScroll = (e) => {
    const scrollTop = e.currentTarget.scrollTop;

    // Debounce writes so we're not hitting localStorage on every pixel
    if (scrollSaveTimeout.current) {
      clearTimeout(scrollSaveTimeout.current);
    }

    scrollSaveTimeout.current = setTimeout(() => {
      localStorage.setItem(
        "sidebarScrollTop",
        String(scrollTop)
      );
    }, 100);
  };

  /* MENU ITEMS */
  const menuItems = [
    {
  name: "DashBoard",
  icon: <FaChartPie />,
  subMenu: [
    {
      name: "Management",
      to: "/finance/dashboard",
    },
        {
      name: "Finance",
      to: "/finance/dashboard/finance-dashboard",
    },
    {
      name: "Controlling",
      to: "#", // TODO: add dashboard route later
    },
    {
      name: "Procurement",
      to: "/cable/stock/dashboard",
    },
    {
      name: "Order Management",
      to: "/cable/sales/dashboard",
    },
    {
      name: "Logistics",
      to: "/cable/logistics/dashboard",
    },
    {
      name: "Planning",
      to: "#", // TODO: add dashboard route later
    },
    {
      name: "Production",
      to: "/cable/production/dashboard",
    },
    {
      name: "Quality",
      to: "#", // TODO: add dashboard route later
    },
  ],
},
    {
      name: "Product Management",
      icon: <FaBox />,
      to: "/cable/product",
    },

    {
      name: "Finance",
      icon: <FaWallet />,
      subMenu: [
       
        

        
        {
          name: "Budget Planning",
          to: "/finance/budget-planning",
        },

        {
          name: "General Ledger",
          to: "/finance/gl",
        },
        {
          name: "Accounts Receivable",
          to: "/finance/ar",
        },
        {
          name: "Accounts Payable",
          to: "/finance",
        },
        {
          name: "Bank Communication",
          to: "/finance/bank-communication",
        },
        {
          name: "Assets Management",
          to: "/finance/assets",
        },
        {
          name: "Localization",
          to: "/finance/localization",
        },
      ],
    },

    {
      name: "Controlling",
      icon: <FaChartPie />,
      subMenu: [
      
        {
          name: "Internal Orders",
          to: "/controlling/IO",
        },
        {
          name: "Product Costing",
          to: "/controlling/product-costing",
        },
      ],
    },

    {
      name: "Procurement",
      icon: <FaShoppingCart />,
      subMenu: [

        // {
        //   name: "Approval Matrix",
        //   to: "/cable/procurement/approval-matrix",
        // },

        {
          name: "Purchasing",
          to: "/cable/procurement",
        },
      ],
    },

    {
      name: "Order Management",
      icon: <FaBoxOpen />,
      subMenu: [
        {
          name: "Business Partner",
          to: "/cable/business-partner",
        },

        {
          name: "Sales",
          to: "/cable/sales",
        },

        {
          name: "Billing",
          to: "/cable/billing",
        }
      ],
    },

    {
      name: "Logistics",
      icon: <FaTruckMoving />,
      subMenu: [
        {
          name: "Inbound Process",
          to: "/cable/inbound-process",
        },
        {
          name: "Outbound Process",
          to: "/cable/outbound-process",
        },
        {
          name: "Inventory Management",
          to: "/cable/inventory-management",
        },
        {
          name: "Warehouse Master",
          to: "/cable/warehouse",
        },
      ],
    },

    {
      name: "Planning",
      icon: <FaProjectDiagram />,
      subMenu: [
        {
          name: "Product Planning",
          to: "/cable/planning",
        },
      ],
    },

    {
      name: "Production",
      icon: <FaIndustry />,
      subMenu: [
        {
          name: "Master Data",
          to: "/cable/master-data",
        },

        {
          name: "Production Scheduling",
          to: "/cable/productionscheduling",
        },

        {
          name: "Shop Floor Control",
          to: "/cable/shop-floor-control",
        },
      ],
    },

    {
      name: "Quality",
      icon: <FaCheckCircle />,
      subMenu: [
        {
          name: "Quality Management",
          to: "/cable/quality",
        },
        {
          name: "Master Data",
          to: "/cable/quality/master-data",
        },
      ],
    },



    {
      name: "Configuration",
      icon: <FaCog />,
      subMenu: [
       {
  name: "Location",
  to: "/cable/location",
},

        {
          name: "Master Configuration",
          to: "/cable/config/master-data",
        },


        {
          name: "User Manual",
          to: "/cable/config/user-manual",
        },
        

        user?.role === "admin" ||
          hasPermission(
            "USER_MANAGEMENT",
            "view"
          )
          ? {
            name: "User Management",
            to: "/cable/user",
          }
          : null,
      ].filter(Boolean),
    },

  


  ];

  /* SUB MENU */
  const renderSubMenu = (
    items,
    key,
    level = 1
  ) => (
    <div
      className={`submenu-wrapper ${openMenus[key] ? "open" : ""
        }`}
    >
      {items.map((item) => {
        const subKey = `${key}-${item.name}`;

        return (
          <div
            key={subKey}
            className="submenu-item"
            style={{
              paddingLeft: `${level * 14}px`,
            }}
          >
            <Link
              className="submenu-link"
              to={item.to || "#"}
            >
              {item.name}
            </Link>
          </div>
        );
      })}
    </div>
  );

  return (
    <>
      <style>{`
        * {
          box-sizing: border-box;
        }

        .sidebar {
          position: fixed;

  top: 86px;
  left: 12px;

  height: calc(100vh - 100px);


          background:
            linear-gradient(
              180deg,
              #02173f 0%,
              #031b4e 45%,
              #02153d 100%
            );

          overflow-y: auto;
          overflow-x: hidden;

          z-index: 1000;

          border-radius: 30px;

          box-shadow:
            8px 0 30px rgba(0,0,0,0.22);

          font-family:
            Inter,
            Poppins,
            sans-serif;

          scrollbar-width: none;

          padding: 18px 14px 24px;
        }

        .sidebar::-webkit-scrollbar {
          display: none;
        }

        /* MENU SECTION */
        .menu-section {
          display: flex;
          flex-direction: column;
          gap: 8px;
        }

        .menu-block {
          width: 100%;
        }

        /* MAIN MENU */
        .menu-item {
          display: flex;
          align-items: center;
          justify-content: space-between;

          padding: 15px 16px;

          border-radius: 18px;

          cursor: pointer;

          transition: all 0.25s ease;

          color: rgba(255,255,255,0.90);

          backdrop-filter: blur(10px);

          user-select: none;
        }

        .menu-item:hover {
          background:
            rgba(255,255,255,0.08);

          transform: translateX(2px);
        }

        .menu-item.active {
          background:
            linear-gradient(
              135deg,
              #1677ff,
              #0057d9
            );

          box-shadow:
            0 10px 24px rgba(22,119,255,0.35);
        }

        .menu-left {
          display: flex;
          align-items: center;
          gap: 14px;

          overflow: hidden;
        }

        .menu-icon {
          min-width: 18px;

          font-size: 17px;

          opacity: 0.95;
        }

        .menu-text {
          font-size: 14px;

          font-weight: 600;

          letter-spacing: 0.2px;

          white-space: nowrap;

          overflow: hidden;

          text-overflow: ellipsis;
        }

        .menu-arrow {
          font-size: 10px;

          transition: 0.25s ease;

          opacity: 0.8;
        }

        .menu-arrow.rotate {
          transform: rotate(90deg);
        }

        /* SUBMENU */
        .submenu-wrapper {
          max-height: 0;

          overflow: hidden;

          transition:
            max-height 0.35s ease;
        }

        .submenu-wrapper.open {
          max-height: 800px;
        }

        .submenu-item {
          margin-top: 6px;
        }

        .submenu-link {
          display: block;

          padding:
            11px 14px 11px 18px;

          border-radius: 14px;

          text-decoration: none;

          color:
            rgba(255,255,255,0.72);

          font-size: 13px;

          font-weight: 500;

          transition: all 0.22s ease;
        }

        .submenu-link:hover {
          background:
            rgba(255,255,255,0.06);

          color: #ffffff;

          transform:
            translateX(3px);
        }

        /* RESIZER */
        .resizer {
          width: 5px;

          cursor: col-resize;

          position: absolute;

          top: 0;
          right: 0;
          bottom: 0;

          z-index: 100;
        }

        .resizer:hover {
          background:
            rgba(255,255,255,0.15);
        }

        /* FOOTER CARD */
        .bottom-card {
          margin-top: 24px;

          padding: 20px;

          border-radius: 22px;

          background:
            linear-gradient(
              180deg,
              rgba(255,255,255,0.08),
              rgba(255,255,255,0.03)
            );

          border:
            1px solid rgba(255,255,255,0.08);

          backdrop-filter: blur(12px);

          color: white;
        }

        .bottom-text {
          font-size: 13px;

          line-height: 1.8;

          opacity: 0.92;

          font-weight: 500;
        }
      `}</style>

      <aside
        ref={sidebarRef}
        onScroll={handleSidebarScroll}
        className="sidebar"
        style={{
          width: `${width}px`,

          transform: isOpen
            ? "translateX(0)"
            : "translateX(-100%)",

          transition: isDragging
            ? "none"
            : "transform 0.3s ease, width 0.3s ease",
        }}
      >
        {/* MENUS */}
        <div className="menu-section">
          {menuItems.map((menu) => {
            const key = menu.name;

            if (!menu.subMenu) {
              return (
                <div
                  key={key}
                  className="menu-block"
                >
                  <Link
                    to={menu.to || "#"}
                    className="menu-item"
                    style={{ textDecoration: "none" }}
                  >
                    <div className="menu-left">
                      <div className="menu-icon">
                        {menu.icon}
                      </div>

                      <span className="menu-text">
                        {menu.name}
                      </span>
                    </div>
                  </Link>
                </div>
              );
            }

            return (
              <div
                key={key}
                className="menu-block"
              >
                <div
                  className={`menu-item ${openMenus[key]
                      ? "active"
                      : ""
                    }`}
                  onClick={() =>
                    toggleMenu(key)
                  }
                >
                  <div className="menu-left">
                    <div className="menu-icon">
                      {menu.icon}
                    </div>

                    <span className="menu-text">
                      {menu.name}
                    </span>
                  </div>

                  <FaChevronRight
                    className={`menu-arrow ${openMenus[key]
                        ? "rotate"
                        : ""
                      }`}
                  />
                </div>

                {renderSubMenu(
                  menu.subMenu,
                  key
                )}
              </div>
            );
          })}
        </div>

        {/* FOOTER CARD */}

        {/* RESIZER */}
        <div
          className="resizer"
          onMouseDown={handleMouseDown}
        />
      </aside>
    </>
  );
};

Sidebar.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  width: PropTypes.number.isRequired,
  isDragging: PropTypes.bool.isRequired,
  handleMouseDown: PropTypes.func.isRequired,
};

export default Sidebar;